<template>
  <v-layout row justify-center>
    <v-dialog
      transition="slide-y-transition"
      v-model="dialog"
      max-width="570"
      persistent
      @keydown.esc="close"
    >
      <v-card class="confirm-dialog">
        <v-card-title>
          <v-layout align-center justify-space-between class="modal-head-label">
            {{ $t('common.labels.changeUserPassword') }}
            <v-icon class="svg-icon ml-4" @click="close()">mdi-close</v-icon>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-form ref="changePasswordForm" lazy-validation>
            <v-text-field
              name='password'
              :placeholder='$t("common.fields.newPasswordPlaceholder") + "*"'
              v-model='credentials.newPassword'
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              :rules='rules.password'
              @click:append="showPassword = !showPassword"
              class="mt-2"
              required
            />
            <v-text-field
              name='repeatPassword'
              :placeholder='$t("common.fields.newRepeatPlaceholder") + "*"'
              v-model='credentials.newPasswordConfirmation'
              :append-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPasswordConfirmation ? 'text' : 'password'"
              :rules='rules.repeatPassword'
              @click:append="showPasswordConfirmation = !showPasswordConfirmation"
              required
            />
          </v-form>
          <v-flex xs12 >
            <!-- Error Alert -->
            <alert-error class="px-3" />
            <!-- Success Alert-->
            <v-layout v-if="successAlert.state" row class="alert-wrapper mt-2 mb-2 px-3">
              <v-flex sm12>
                <v-alert :value="successAlert.state" type="success">
                  {{ successAlert.message }}
                </v-alert>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-layout align-center justify-center class="btns-wrapper mt-4 mb-4">
            <v-btn
              type="button"
              :ripple="false"
              :disabled="isLoading"
              class="warning mb-4"
              depressed
              @click="savePassword()"
            >{{ $t('common.btns.confirm') }}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import AlertError from '@/components/shared/AlertError.vue';

export default {
  name: 'ChangePasswordDialog',
  data() {
    return {
      credentials: {
        newPassword: null,
        newPasswordConfirmation: null,
      },
      rules: {
        password: [
          (v) => !!v || this.$t('common.fields.validation.field.required'),
          (v) => /^[a-zа-яA-ZА-Я0-9!@#$%^&*)(+=._-]{4,}$/.test(v) || this.$t('common.fields.validation.driverPassword'),
        ],
        repeatPassword: [
          (v) => v === this.credentials.newPassword || this.$t('common.fields.validation.password.dontMatch'),
        ],
      },
      showPassword: false,
      showPasswordConfirmation: false,
    };
  },
  props: {
    dialog: Boolean,
    driverId: String,
    investorId: String,
  },
  computed: {
    ...mapGetters({
      isLoading: 'global/getLoader',
      successAlert: 'global/getAlertSuccess',
    }),
  },
  components: {
    AlertError,
  },
  methods: {
    ...mapMutations({
      clearAlertError: 'global/clearAlertError',
      clearAlertSuccess: 'global/clearAlertSuccess',
      setAlertSuccess: 'global/setAlertSuccess',
      setLoader: 'global/setLoader',
    }),
    ...mapActions({
      changePassword: 'user/changePassword',
    }),
    async savePassword() {
      if (this.$refs.changePasswordForm.validate()) {
        this.setLoader(true);
        const userData = {
          data: this.credentials,
        };
        if (this.investorId) {
          userData.type = 'investors';
          userData.id = this.investorId;
        } else {
          userData.type = 'drivers';
          userData.id = this.driverId;
        }
        try {
          const response = await this.changePassword(userData);
          if (response.success) {
            const successAlert = {
              state: true,
              message: this.$t('driver.saving.success'),
            };
            if (response.data.message) {
              successAlert.message = response.data.message;
            }
            this.clearAlertError();
            this.setAlertSuccess(successAlert);
            const that = this;
            setTimeout(() => {
              that.setLoader(false);
              that.close();
            }, 2500);
          }
        } catch (error) {
          this.setLoader(false);
        }
      }
    },
    close() {
      this.clearAlertSuccess();
      this.setLoader(false);
      this.clearAlertError();
      this.clearCredentials();
      this.$emit('update:dialog', false);
    },
    clearCredentials() {
      this.credentials.newPassword = null;
      this.credentials.newPasswordConfirmation = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-head-label {
  word-break: break-word;
}
</style>
